module.exports = __webpack_public_path__ + "static/media/introMEGA.3cf8f75.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/introMEGA.mp4
// module id = 5ze/
// module chunks = 0